import React from "react";
import { connect } from "react-redux";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { Results } from "./Results";
import { NavLink } from "react-router-dom";
import { Filter } from "./Filter";
import { PageDisplay, Pages, SubPageDisplay, SubPages } from "../../../../store/AppDisplays";
import { UserInfo, UserRoles } from "../../../../store/AppTypes";
import { ReduxState, isRemoteLoading } from "../../../../store/ReduxState";
import { RemoteScope } from "../../../../store/RemoteTypes";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Tariffs as TariffsType } from "../../../../store/Tariffs/Types";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { Icon, IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: TariffsType;
    user?: UserInfo;
}
type Props = StateProps;
/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.TARIFF_RESULTS),
    results: s.prop("remote").prop(RemoteScope.TARIFF_RESULTS),
    user: s.prop("user").isPresent() ? s.prop("user").get() : undefined,
});
/**
 *
 * @param props
 */
export class TariffsComp
    extends React.Component<Props, {}> {
    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }
    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Div className="scl-b-row">
                        <Grid
                            size={{ xs: 12, md: 8 }}
                        >
                            <Header
                                title={PageDisplay[Pages.TARIFFS].title}
                                description={PageDisplay[Pages.TARIFFS].description}
                            />
                        </Grid>
                        {this.props.user?.userRole !== UserRoles.EW_ADMIN_READONLY &&
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <Div
                                    style={{ textAlign: "right" }}
                                >
                                        <NavLink to={SubPageDisplay[SubPages.TARIFF_CREATE].path}>
                                            <Button
                                                theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                                className="scl-a-btn--big"
                                            >
                                                {SubPageDisplay[SubPages.TARIFF_CREATE].title}
                                            &nbsp;
                                            &nbsp;
                                                <Icon name={IconNames.ARROW_RIGHT} />
                                            </Button>
                                        </NavLink>
                                </Div>
                            </Grid>}
                    </Div>
                    <Filter
                        loadingFilters={this.props.loadingFilters}
                        loadingResults={this.props.loadingResults}
                        currentPage={Pages.TARIFFS}
                    />
                    <Results
                        results={this.props.results}
                        loadingResults={this.props.loadingResults}
                        currentPage={Pages.TARIFFS}
                        scope={RemoteScope.TARIFF_RESULTS}
                    />
                </Container>
            </Page>
        );
    }
}
/**
 *
 */
export const Tariffs = connect(
    mapStateToProps,
    undefined,
)((props: Props) => <TariffsComp {...props}/>);
